import emailjs from '@emailjs/browser';

class SecureTracker {
  constructor() {
    this.hasTracked = false;
  }

  async sendSecureAnalytics(type, visitorInfo, email = null) {
    try {
      // Prepare template variables - only these will be visible in network tab
      const templateParams = {
        // Basic identifiers
        analytics_type: type, // 'visit', 'email_capture', 'modal_dismiss'
        visitor_email: email || 'Not provided',
        
        // Visitor data as separate variables
        timestamp: visitorInfo.timestamp || new Date().toLocaleString(),
        timezone: visitorInfo.timezone || 'N/A',
        session_id: visitorInfo.sessionId || 'N/A',
        
        // Location
        ip_address: visitorInfo.ip || 'N/A',
        city: visitorInfo.city || 'N/A',
        region: visitorInfo.region || 'N/A',
        country: visitorInfo.country || 'N/A',
        country_code: visitorInfo.countryCode || 'N/A',
        isp: visitorInfo.isp || 'N/A',
        
        // Device & Browser
        device_type: visitorInfo.deviceType || 'N/A',
        operating_system: visitorInfo.operatingSystem || 'N/A',
        browser: visitorInfo.browser || 'N/A',
        screen_resolution: visitorInfo.screenResolution || 'N/A',
        window_size: visitorInfo.windowSize || 'N/A',
        
        // User preferences
        language: visitorInfo.language || 'N/A',
        all_languages: visitorInfo.languages || 'N/A',
        cookies_enabled: visitorInfo.cookieEnabled || 'N/A',
        online_status: visitorInfo.onlineStatus || 'N/A',
        
        // Additional screen info
        color_depth: visitorInfo.colorDepth || 'N/A',
        pixel_ratio: visitorInfo.pixelRatio || 1,
        platform: visitorInfo.platform || 'N/A',
        
        // Connection
        connection_type: visitorInfo.connectionType || 'N/A',
        connection_speed: visitorInfo.connectionDownlink || 'N/A',
        
        // Performance
        time_on_site: visitorInfo.timeOnSite || 0,
        load_time: visitorInfo.loadTime || 'N/A',
        
        // Navigation
        referrer: visitorInfo.referrer || 'Direct visit',
        current_url: visitorInfo.currentUrl || window.location.href,
        user_agent: visitorInfo.userAgent || navigator.userAgent
      };

      // Send using the analytics template
      await emailjs.send(
        'service_tq7rqy1', 
        'template_b5tj3sk', // Your analytics template ID
        templateParams, 
        'DdicUw29yGs6HtHSS'
      );

      console.log(`📊 ${type} analytics sent securely`);
      return true;
      
    } catch (error) {
      console.error('❌ Secure analytics failed:', error);
      return false;
    }
  }

  async trackVisit(visitorInfo) {
    if (this.hasTracked || sessionStorage.getItem('visitor_tracked')) {
      return;
    }

    const success = await this.sendSecureAnalytics('visit', visitorInfo);
    if (success) {
      this.hasTracked = true;
      sessionStorage.setItem('visitor_tracked', 'true');
    }
  }

  async trackEmailCapture(email, visitorInfo) {
    await this.sendSecureAnalytics('email_capture', visitorInfo, email);
  }

  async trackModalDismiss(visitorInfo) {
    await this.sendSecureAnalytics('modal_dismiss', visitorInfo);
  }
}

export default new SecureTracker();
